import {
  HorseRaceIconNotSelected,
  HorseRaceIconSelected,
  IndividualIconNotSelected,
  IndividualIconSelected,
  SkinsIconNotSelected,
  SkinsIconSelected,
  CTPIconNotSelected,
  CTPIconSelected,
  MoneyBallIconNotSelected,
  MoneyBallIconSelected,
  ScrambleIconSelected,
  ScrambleIconNotSelected
} from '../../../../../assets/images';

export const iconsMap = {
  ctp: { selected: CTPIconSelected, notSelected: CTPIconNotSelected },
  gbn: { selected: SkinsIconSelected, notSelected: SkinsIconNotSelected },
  horse: { selected: HorseRaceIconSelected, notSelected: HorseRaceIconNotSelected },
  moneyball: { selected: MoneyBallIconSelected, notSelected: MoneyBallIconNotSelected },
  scramble: { selected: ScrambleIconSelected, notSelected: ScrambleIconNotSelected },
  skins: { selected: SkinsIconSelected, notSelected: SkinsIconNotSelected },
  stroke: { selected: IndividualIconSelected, notSelected: IndividualIconNotSelected }
};
